"use client";

import { VisualEditing as VisualEditingNextSanity } from "next-sanity/visual-editing";
import DisableDraftButton from "../DisableDraftButton";

const VisualEditing = () => (
  <>
    <VisualEditingNextSanity />
    <DisableDraftButton />
  </>
);

export default VisualEditing;
